/**
 * Javascript for custom dropdowns
 */

(function (window, document, $, undefined) {

    'use strict';

    var $selects = $('select').not(".filter-select, .share-class-select, #frequency-distribution-quarter-select, .selectpicker, .gfield_select, #locations-region"); //also not including share-class-select

    $selects.each(function(){
        $(this).wrap('<div class="jh-dropdown"></div>');
        $(this).before('<span>&#xf107;</span>');
    });

	$selects.on('mousedown', function(e) {
		if ( $(this).hasClass('disabled') ) {
			preventEvent(e, this);
		}
	});

	$selects.on("keydown", function (e) {
		if (e.keyCode == 32 && $(this).hasClass('disabled')) {
			preventEvent(e, this);
		}
	});

	function preventEvent(e, thisRef) {
		e.preventDefault();
		$(thisRef).trigger('notallowed');
		thisRef.blur();
		window.focus();
	}

	/*
	 * Subscription Top Nav Dropdown
	 */
	$('#subscription-button').on('click', function() {
		const $button = $(this);
		const $dropdown = $('#subscription-dropdown');

		// Calculate button position
		const $buttonOffset = $button.offset();
		const $buttonHeight = $button.outerHeight();
		const $buttonWidth = $button.outerWidth();
		const $offsetParent = $button.offsetParent();
		const $parentOffset = $offsetParent.offset();

		// Set dropdown position
		$dropdown.css({
			top: $buttonOffset.top - $parentOffset.top + $buttonHeight + 'px',
			left: $buttonOffset.left - $parentOffset.left + $buttonWidth - $dropdown.outerWidth()
		});

		// Button class toggle
		$button.toggleClass('is-open');

		// Toggle dropdown visibility
		if ($dropdown.hasClass('open')) {
			$dropdown.removeClass('open');
			setTimeout(function() {
				$dropdown.css('display', 'none');
			}, 250); // Match the transition duration
		} else {
			$dropdown.css('display', 'block');
			setTimeout(function() {
				$dropdown.addClass('open');
			}, 10); // Slight delay to trigger the transition
		}
	});

	// Close dropdown if clicked outside
	$(document).on('click', function(event) {
		const $dropdown = $('#subscription-dropdown');
		const $button = $('#subscription-button');

		if (!$dropdown.is(event.target) && !$button.is(event.target) && $dropdown.has(event.target).length === 0 && $button.has(event.target).length === 0) {
			if ($dropdown.hasClass('open')) {
				$dropdown.removeClass('open');
				setTimeout(function() {
					$dropdown.css('display', 'none');
				}, 250); // Match the transition duration
			}
		}
	});

})( window, document, jQuery );
